import styled from 'styled-components';
import Button from 'products/nomad_insurance/components/Button';

export const StyledButton = styled(Button)`
  width: ${({ fullWidth }) => (fullWidth ? '100%' : 'fit-content')};
`;
